// extracted by mini-css-extract-plugin
export default {"AddTrustedDomainDialog":"vvovrP50sBePaiutImqWAA==","TrustedDomainsTable":"_7YtkkWdI3OW3uV-NulVeig==","TrustedDomainsTableActions":"cz5QcYF0lvGNqH9-y-KkRA=="};